import { useLazyQuery } from '@apollo/client';
import gql from 'graphql-tag';

const GET_COMMUNITY_DRIVE_DRIVER_DETAILS = gql`
  query GetCommunityDriveDriverDetails($policyId: ID!, $driverId: String!, $policyEndDate: String!, $state: String!) {
    getCommunityDriveDriverDetails(policyId: $policyId, driverId: $driverId, policyEndDate: $policyEndDate, state: $state) {
      driverId
      presentInWarehouse
      premiumScore
      tripCount
      scoreUpdateDate
      scoringCutoffDate
    }
  }
`;

const useCommunityDriveDetails = ({ policyId, driverId, policyEndDate, state }) => {
  const [fetchDetails, { data, loading, error, called }] = useLazyQuery(GET_COMMUNITY_DRIVE_DRIVER_DETAILS, {
    variables: { policyId, driverId, policyEndDate, state },
    fetchPolicy: 'no-cache'
  });

  return {
    fetchDetails,
    details: data?.getCommunityDriveDriverDetails || null,
    loading,
    error,
    called
  };
};

export default useCommunityDriveDetails;
